//Install
import React, { Component } from "react";
//Install
import { ReactComponent as Z888NA } from "../../../../../Media/Brand/001.svg";

//Element
class P8932D extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S0u16d C96Q4r vR05U6 d721Vx m664pn" },
            //Element
            React.createElement(Z888NA, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default P8932D;